import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentImageWithText } from '../../components/SectionContentImageWithText'
import type { ImageProps } from '../../components/Image'

interface ProResourcesContent {
  heading: string
  description: string
  image: Omit<ImageProps, 'loading' | 'fetchPriority' | 'sizes'>
}

export const SectionContentInstanceProResources: React.FunctionComponent<
  ProResourcesContent
> = ({ heading, description, image }) => (
  <Section backgroundColor="white" padding={100} prerender>
    <SectionContentImageWithText
      heading={heading}
      headingComponent="h1"
      description={{ description }}
      imagePlacement="left"
      image={image}
      showAppStoreLinks={false}
    />
  </Section>
)

export const candlelightProResources: ProResourcesContent = {
  heading: 'Important Information for Your Candlelight Shift',
  description:
    'You’ve been selected to work a Candelight shift through Qwick. Event-specific expectations, attire, and logistics are outlined [here](https://docs.google.com/document/d/e/2PACX-1vRKK1W_Mcun-vrIDUfm4qJztbImyNZdG_a7eikeHOlmLnwjAyQ3jVU6o9EUpuJTa60ZWBVxCKw6I2F0/pub?urp=gmail_link#h.kjbec24wwniw) as well as in a [training video here](https://drive.google.com/file/d/1FM5zG3DZIQ8hgvyLXpxc-IFsSYgSWVT0/view). \n\nPlease review both resources in advance to ensure you arrive prepared and ready to support a successful event.',
  image: { publicId: 'photography/candlelight', alt: 'Candlelight concert' },
}

export const droneArtShowProResources: ProResourcesContent = {
  heading: 'Important Information for Your Drone Art Show Shift',
  description:
    'You’ve been selected to work a Candelight shift through Qwick. Event-specific expectations, attire, and logistics are outlined [here](https://docs.google.com/document/d/e/2PACX-1vRYFnU11jzl7YzaEW0rUVwzRIh5_57DmgkfSs_88nR3RwiQs0wFqMcXIYQjcQrWjFi_-HyqFpkDdzis/pub) as well as in a [training video here](https://drive.google.com/file/d/1FM5zG3DZIQ8hgvyLXpxc-IFsSYgSWVT0/view). \n\nPlease review both resources in advance to ensure you arrive prepared and ready to support a successful event.',
  image: { publicId: 'photography/drone-art-show', alt: 'drone art show ' },
}
